<template>
  <BQdtCard
    name="turnoverTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'DimensionsHeader',

  components: { BQdtCard },
}
</script>
